import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import Form from '../Form'

class StaticInput extends React.PureComponent {
  render() {
    return (
      _.isString(this.props.label)
        ? <React.Fragment>
            <Form.Row
              className={ this.props.smallPadding ? 'small-padding' : '' }
              error={ !!this.props.error }
            >
              <label>
                {this.props.label}
              </label>
              {this.props.content}
            </Form.Row>
            {
              this.props.error
                ? <Form.Row
                    className='small-padding'
                    style={{
                      color: '#9f3a38'
                    }}
                  >
                    <label />
                    {this.props.error}
                  </Form.Row>
                : null
            }
          </React.Fragment>
        : this.props.content
    )
  }
}

StaticInput.propTypes = {
  label: PropTypes.string, // if missing, rendered without Form structure
  content: PropTypes.node.isRequired,
  error: PropTypes.string,
  smallPadding: PropTypes.bool
}

export default StaticInput



// WEBPACK FOOTER //
// ./src/components/elements/forms/StaticInput.js